export const SEC_LOGIN = require("./background_SEC.jpg");
export const MARKER_ICON = require("./marker.png");
export const TEMPLATE_DNI = require("./DNI.png");
export const LOGO_APP = require("./logo.png");
export const LOGO_APP_DARK = require("./logo-dark.png");
export const LOGO_ENERGY = require("./energia.png");
export const LOGO_SEC = require("./logo-SEC.png");
export const LOGO_LOGIN = require("./login-template.png");
export const LOGO_HEADER = require("./logoHeader.png");
